import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import DeviationDuperbrowseContext from '../../../../Duperbrowse/DeviationDuperbrowseContext';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DeviationDumbViewWithIcon from '../../../../DeviationViews/DumboWithIcon';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { getDeviationResourceType, getTranslatedDeviationTitle } from '../../../../DeviationViews/_helpers';
import ContainerSize from '../../../../ContainerSize';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import s from './SingleColumnTextual.scss';
const thumbHeight = parseInt(s['sidebar-thumb-height'], 10);
const thumbWidth = parseInt(s['sidebar-thumb-width'], 10);
/** Sidebar block layout id 2 */ const SingleColumnTextual = ({ block, deviation: parentDeviation })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    return /*#__PURE__*/ React.createElement(SidebarBlockWrapper, {
        deviation: parentDeviation,
        block: block
    }, /*#__PURE__*/ React.createElement(ContainerSize, null, ({ containerWidth })=>{
        var _block_deviations;
        var _block_deviations1;
        return /*#__PURE__*/ React.createElement(DeviationDuperbrowseContext, {
            streamId: `sidebar-textual-${block.contentType}`,
            deviations: (_block_deviations1 = block.deviations) !== null && _block_deviations1 !== void 0 ? _block_deviations1 : [],
            parent: {
                typeId: getDeviationResourceType(parentDeviation),
                itemId: parentDeviation.deviationId
            }
        }, (_block_deviations = block.deviations) === null || _block_deviations === void 0 ? void 0 : _block_deviations.map((deviation, index)=>/*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
                key: index,
                value: {
                    _rankIndex: index
                }
            }, /*#__PURE__*/ React.createElement(DeviationLink, {
                deviation: deviation,
                key: deviation.deviationId,
                className: s['thumb'],
                title: getTranslatedDeviationTitle(deviation, t)
            }, /*#__PURE__*/ React.createElement(DeviationDumbViewWithIcon, {
                deviation: deviation,
                width: isMobile ? containerWidth : thumbWidth,
                height: thumbHeight,
                greenLikeCrop: true
            })))));
    }));
};
SingleColumnTextual.displayName = 'SingleColumnTextual';
export default SingleColumnTextual;

//# sourceMappingURL=SingleColumnTextual.js.map